/**
 * Factory for WebSked integrations
 * @author Brendan Magee
 */

function IntegrationFactory($http) {
  return class Integration {
    constructor(integrationData = {}) {
      Object.assign(this, integrationData);
    }

    static getAll() {
      return $http.get(Integration.endpoint)
        .then((response) => {
          if (response && Array.isArray(response.data)) {
            return response.data.map(integration => new Integration(integration));
          }

          return [];
        });
    }

    static getAllByType(type = 'slack') {
      return $http.get(Integration.endpoint, { params: { type } })
        .then(response => response.data.map(integration => new Integration(integration)));
    }

    static get endpoint() {
      return 'api/company/integrations';
    }
  };
}

const factoryArray = [
  '$http',
  IntegrationFactory
];

export default function (ngModule) {
  ngModule.factory('Integration', factoryArray);
}
